import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSession } from 'components/Providers'
import { runWidget } from 'store/widget'

export default function useWidget(code) {
  const dispatch = useDispatch()
  const { person, academicYear } = useSession()
  const type = person?.type

  const data = useSelector(state => state.widget.data[code])
  const loading = useSelector(state => state.widget.loading[code])
  const error = useSelector(state => state.widget.error[code])

  const [tried, setTried] = useState(false)
  const requested = useRef(false)

  useEffect(() => {
    if (code && type && data === undefined && !requested.current) {
      requested.current = true
      dispatch(runWidget({ type, code }))
    }

    setTried(true)
  }, [dispatch, code, type, academicYear?.id, data])

  return { data, loading: Boolean(loading), error, isReady: tried && !loading }
}
